import React from "react";
export default function LanguageSelector({
                                             language, onSelect
                                         }) {
    const languages = [{
        code: "en", name: "English", native: "English", flag: "🇬🇧"
    }, {
        code: "ta", name: "Tamil", native: "தமிழ்", flag: "🇮🇳"
    }, {
        code: "ms", name: "Malay", native: "Bahasa Melayu", flag: "🇲🇾"
    },];
    return (<div className="card shadow-sm mb-3">

        <div className="card-body">

            <h4 className="text-center mb-4">

                Select Your Language

            </h4>

            <div className="row">

                {languages.map(lang => (<div

                    className="col-md-4 mb-3"

                    key={lang.code}

                >

                    <button
                        className={
                            language === lang.code
                                ? "btn btn-primary w-100 p-4"
                                : "btn btn-outline-primary w-100 p-4"
                        }
                        onClick={() => onSelect(lang.code)}
                        style={{
                            minHeight: 180,
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center"
                        }}
                    >
                        <div

                            style={{
                                fontSize: 42
                            }}

                        >

                            {lang.flag}

                        </div>

                        <h5 className="mt-3">

                            {lang.name}

                        </h5>

                        <div>

                            {lang.native}

                        </div>

                    </button>

                </div>))}

            </div>

        </div>

    </div>);
}